import { Navigate, Outlet } from 'react-router-dom'
import { useMemo } from 'react'

import { Container, NavTabs, Stack, Text } from '../../../components'
import { useUserIsOnMobileApp } from '../../../hooks/useUserIsOnMobileApp'
import { useAuth } from '../../../hooks'
import { useAdvisorPermissions } from '../../../hooks/useAdvisorPermissions'

// Redirect component that routes to the appropriate default tab based on user role
export function ContributeRedirect() {
  const { isAdvisorImpersonating } = useAdvisorPermissions()

  // Advisors can only use Securities, donors default to Credit Card
  return <Navigate to={isAdvisorImpersonating ? 'securities' : 'credit-card'} replace />
}

export function Contribute() {
  const isReactNative = useUserIsOnMobileApp()
  const [{ isImpersonating, impersonationType }] = useAuth()
  const { isAdvisorImpersonating } = useAdvisorPermissions()

  const navigation = useMemo(() => {
    // Advisors can only use Securities and Initiated Contributions
    if (isAdvisorImpersonating) {
      return [
        { label: 'securities', to: 'securities', text: 'Securities', testId: 'nav-tab-securities' },
        {
          label: 'initiated contributions',
          to: 'initiated-contributions',
          text: 'Initiated Contributions',
          testId: 'nav-tab-initiated-contributions',
        },
      ]
    }

    // Full methods for regular users (donors)
    return [
      { label: 'credit card', to: 'credit-card', text: 'Credit Card', testId: 'nav-tab-credit-card' },
      { label: 'Bank Transfer', to: 'bank-transfer', text: 'Bank Transfer', testId: 'nav-tab-bank-transfer' },
      ...(isReactNative
        ? [{ label: 'apple pay', to: 'apple-pay', text: 'Apple Pay', testId: 'nav-tab-apple-pay' }]
        : []),
      { label: 'e-transfer', to: 'e-transfer', text: 'E-transfer', testId: 'nav-tab-e-transfer' },
      { label: 'cheque', to: 'cheque', text: 'Cheque', testId: 'nav-tab-cheque' },
      { label: 'DAF Transfer', to: 'daf-transfer', text: 'DAF Transfer', testId: 'nav-tab-daf-transfer' },
      { label: 'securities', to: 'securities', text: 'Securities', testId: 'nav-tab-securities' },
      { label: 'Other Assets', to: 'other-assets', text: 'Other Assets', testId: 'nav-tab-other-assets' },
    ]
  }, [isAdvisorImpersonating, isReactNative])

  return (
    <>
      <Container maxWidth="lg" sx={{ mb: 0 }}>
        <Text.H1>Make a Contribution</Text.H1>
        <Stack>
          <NavTabs tabs={navigation} />
        </Stack>
      </Container>
      <Outlet />
    </>
  )
}
